define('modules/home/main/views/side.menu.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "bootstrap",
    /*"modules/home/sidebar/views/search.view",
    "modules/home/sidebar/views/lists.view",
    "modules/home/sidebar/views/settings.view",*/
    "modules/home/sidebar/views/alerts.view",
    "text!modules/home/main/templates/side.menu.template.html"
], function(Prospector, $,_,Backbone,
            Marionette,
            Bootstrap,
           // SearchView,
           // ListsView,
            //SettingsView,
            AlertsView,
            Template
) {
    var SideMenuView = Marionette.ItemView.extend({
        template: _.template(Template),
        className: 'sideMenu',
        initialize:function(){
            Prospector.on('closeSideDrawer', this.closeSideDrawer, this);
            Prospector.on('openSideDrawer', this.openSideDrawer, this);
            Prospector.on('updateBadgeCount', this.updateBadgeCount, this);
            Prospector.on('refreshAlertsCount', this.updateAlertsCount, this);
            Prospector.on('refreshLists', this.updateListCount, this);
            //window.user.bind('sync', this.updateListCount, this);
            this.currentView = "";
            this.positions = {};
        },
        events:function(){
            return {
                'click .search' :  'loadSearch',
                'click .lists' :  'loadLists',
                'click .alerts' :  'loadAlerts',
                'click .settings' :  'loadSettings',
                'click .techstack' :  'loadTechStack',
                'click .topicMaker' :  'loadTopicMaker',
                'click .advSearch' :  'loadAdvSearch',
                'click .feedback' :  'showFeedback'
            };
        },
        updateListCount:function(){
            if (window.user.has('id')){
                var listCount = 0;
                _.each(window.user.get('lists'), function(list){
                    if(list.source.sourceId != 2020){
                        listCount++;
                    }
                }, this);
                this.updateBadgeCount({
                    name: 'lists',
                    count: listCount
                });
            }
        },
        updateAlertsCount:function(){
            var profileSettings = window.user.get('userSettings')[1].userSettingsLevel1;
            var alerts = window.user.get('summary')[profileSettings[6].value];
            var rAlerts = window.user.get('summary')[profileSettings[7].value];
            var rCountMode = profileSettings[12].value;

            var total = 0;

            if(rCountMode == "0"  || rCountMode == "2" ){
                total += alerts;
            }

            if(rCountMode == "1"  || rCountMode == "2" ){
                total += rAlerts;
            }

            this.updateBadgeCount({
                name: 'alerts',
                count: total
            });
        },
        onRender:function(){
            //this.updateAlertsCount();
           /* this.updateListCount();
            this.searchView = new SearchView();
            $('.searchViewHolder').append(this.searchView.render().el);

            this.listsView = new ListsView();
            $('.listsViewHolder').append(this.listsView.render().el);*/

            this.alertsView = new AlertsView();
            $('.alertsViewHolder').append(this.alertsView.render().el);

           /* this.settingsView = new SettingsView();
            $('.settingsViewHolder').append(this.settingsView.render().el);

            this.closeSideDrawers();*/
        },
        showFeedback:function() {
            window.doorbell.setOption('email', window.user.get('email'));
            window.doorbell.setProperty('RelProUserSettings', window.user.attributes);
            window.doorbell.setProperty('RelProUserEntitlements', window.entitlements.attributes);
            window.doorbell.show();
        },
        loadTechStack:function(e){
            this.closeSideDrawer();
            Prospector.trigger('clearFormState');
            Prospector.navigate('techstack',true);
        },
        loadTopicMaker:function(e){
            this.closeSideDrawer();
            Prospector.navigate('topicMaker',true);
        },
        loadSearch:function(e){
            this.loadSubApp('.searchViewHolder', e);
        },
        loadAdvSearch:function(e){
            this.closeSideDrawer();
            Prospector.trigger("clearAdvanceSearch",{
                passedFunc:function(){
                    Prospector.navigate('advanceSearch',true);
                }
            });
        },
        loadLists:function(e){
            this.loadSubApp('.listsViewHolder', e);
        },
        loadSettings:function(e){
            this.loadSubApp('.settingsViewHolder', e);
        },
        loadAlerts:function(e){
            this.loadSubApp('.alertsViewHolder', e);
        },
        loadSubApp:function(app, e){
            if(this.currentView != app){
                this.closeSideDrawers();
                $(app).show(0, $.proxy(function(){
                    if(this.positions[app] != undefined && this.positions[app] != 0){
                        $('#sidebar-wrapper').animate({
                            scrollTop: this.positions[app]
                        }, 0);
                    }
                }, this));
                if($("#wrapper").hasClass("toggled")){
                    this.openSideDrawer();
                }
                $(".sideMenu .verticalIcon").removeClass('active');
                e.currentTarget.classList.add('active');
            } else {
                if($("#wrapper").hasClass("toggled")){
                    this.openSideDrawer();
                    e.currentTarget.classList.add('active');
                    $(app).show(0, $.proxy(function(){
                        if(this.positions[app] != undefined && this.positions[app] != 0){
                            $('#sidebar-wrapper').animate({
                                scrollTop: this.positions[app]
                            }, 0);
                        }
                    }, this));
                } else {
                    this.closeSideDrawer();
                }
            }
            this.currentView = app;
        },
        closeSideDrawers: function(){
            if(!$("#wrapper").hasClass("toggled")) {
                this.positions[this.currentView] = $('#sidebar-wrapper').scrollTop();
            }
            var apps = ['.searchViewHolder', '.listsViewHolder', '.alertsViewHolder','.settingsViewHolder'];
            _.each(apps, function(app){
               $(app).slideUp();
            });
        },
        openSideDrawer:function(options){
            Prospector.trigger('closeHistoryDrawer');
            if($("#wrapper").hasClass("toggled")){
                $("#wrapper").removeClass("toggled");
            }
            if(options != undefined && options.passedFunc != undefined){
                options.passedFunc();
            }
            if(options != undefined && options.app != undefined){
                this.app = options.app;
            }
        },
        closeSideDrawer:function(options){
            this.closeSideDrawers();
            $(".sideMenu .verticalIcon").removeClass('active');
            if(!$("#wrapper").hasClass("toggled")){
                $("#wrapper").addClass("toggled");
            }
            if(options != undefined && options.passedFunc != undefined){
                options.passedFunc();
            }
        },
        updateBadgeCount:function(options){
            var selector = this.$('.' + options.name + ' .badge').remove();
            if(options.count > 0){
                var mainDiv = "";
                if(options.name == "alerts"){
                    this.$('.alerts .fa').removeClass('swing').addClass('swing');
                    window.setTimeout(function(){
                        $('.alerts .fa').removeClass('swing');
                    }, 1200);
                    mainDiv = '<span class="badge badge-success pull-right">'+ options.count +'</span>';
                }else {
                    mainDiv = '<span class="badge badge-success animated rubberBand pull-right">'+ options.count +'</span>';
                }
                this.$('.' + options.name).append(mainDiv);
            }
        }
    });
    return SideMenuView;
});
